export default "__VITE_ASSET__BQ05cuL5__"